import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ActionTone = 'positive' | 'primary' | 'link' | 'warning' | 'destructive' | 'ai' | 'neutral';

export interface ActionTextProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: ActionTone;
  icon?: ReactNode;
}

export function ActionText({ tone = 'link', icon, className = '', children, type = 'button', ...props }: ActionTextProps) {
  return (
    <button
      type={type}
      className={`altios-action-text altios-action-text--${tone} ${className}`.trim()}
      {...props}
    >
      {icon ? <span aria-hidden="true">{icon}</span> : null}
      <span>{children}</span>
    </button>
  );
}
